/**
 * Shared helpers for working with coin balances and challenge stakes.
 */

export const normalizeCoinAmount = (value: number | null | undefined): number => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return 0;
  }

  return Math.max(0, Math.trunc(value));
};

export const formatCoinsLabel = (value: number | null | undefined): string => {
  return `${normalizeCoinAmount(value).toLocaleString()} coins`;
};

export const hasEnoughCoins = (
  availableCoins: number | null | undefined,
  requiredCoins: number | null | undefined
): boolean => {
  return normalizeCoinAmount(availableCoins) >= normalizeCoinAmount(requiredCoins);
};
